"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Reset accuracy values for notes and drumrolls on the next measure. Placing it
 * near `#BRANCHSTART` or a measure before does not reset the accuracy for that
 * branch. The value is calculated before it and a measure has not started yet
 * at that point.
 *
 * **Example:**
 *
 * ```
 * 11111111,
 * ,
 * #SECTION
 * #BRANCHSTART p,50,75
 * #BRANCHEND
 * 11111111,
 * ,
 * #BRANCHSTART p,50,75
 * #BRANCHEND
 * 11111111,
 * ```
 */
class SectionCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.Section);
    }
    static parse(_args) {
        return new SectionCommand();
    }
}
exports.SectionCommand = SectionCommand;
